import { trailingExit } from './trailingStop';

/**
 * The trend icon a signal row shows: 'up' (green), 'flat' (neutral), 'down'
 * (red) or 'faded' (amber, closed some other way). A trailing stop-out follows
 * its R like its chip does (DWLF-363): it keeps status 'Stopped Out' but is
 * often a profit.
 */
export const signalRowTrend = (signal, { active, hitTarget, stopped }) => {
  if (active || hitTarget) {return 'up';}
  const trailed = trailingExit(signal);
  if (trailed) {
    return { won: 'up', flat: 'flat', lost: 'down' }[trailed.outcome];
  }
  return stopped ? 'down' : 'faded';
};
